import { gql } from 'apollo-boost'

const COMPLETED_MENU_CRAWLING_JOBS_FOR_MENU = gql`
  query completedMenuCrawlingJobsForMenu($menuId: ID!) {
    completedMenuCrawlingJobsForMenu(menuId: $menuId) {
      id
      completedDate
      crawlingStatus
    }
  }
`

export default COMPLETED_MENU_CRAWLING_JOBS_FOR_MENU
